import React from 'react';

import { useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';

import { Stack } from '@atlaskit/primitives/compiled';
import Select from '@atlaskit/select/default';
import type { OptionType } from '@atlaskit/select/types';
import TextArea from '@atlaskit/textarea/text-area';

import { OTHER_ID } from '../../../../../../../../common/types/form/form-fields/field-values';
import {
	asFormOptionField,
	toOptions,
} from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';
import { messages } from './messages';

export const PreviewSingleSelectInput = ({
	fieldId,
	fieldInputId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);
	const formField = useFormField({ fieldId });
	const formOptionField = asFormOptionField(formField);
	const intl = useIntl();

	if (formOptionField === undefined) {
		return <></>;
	}

	return (
		<Stack testId="field-input-single-select-preview" space="space.050">
			<Select<OptionType>
				key={fieldInputId}
				inputId={fieldInputId}
				value={
					formOptionField.value?.otherOptionText !== undefined
						? { value: OTHER_ID, label: intl.formatMessage(messages.otherOption) }
						: (toOptions(formOptionField.value?.options)[0] ?? null)
				}
				placeholder=""
				isDisabled
			/>
			{formOptionField.value?.otherOptionText && (
				<TextArea
					isDisabled
					value={formOptionField.value.otherOptionText}
					aria-label={intl.formatMessage(messages.otherOptionTextLabel, { label: formField.label })}
				/>
			)}
		</Stack>
	);
};
